import { z } from 'zod';
/**
 * Consistent API response envelope (FR §14.1).
 * Every response carries `status`, plus `data` OR `error`, and a `traceId`.
 */
export const ApiErrorShape = z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
});
export const PaginationQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
/** Stable, well-known error codes used across modules. */
export const ErrorCode = {
    UNAUTHENTICATED: 'unauthenticated',
    FORBIDDEN: 'forbidden',
    INSUFFICIENT_SCOPE: 'insufficient_scope',
    NOT_FOUND: 'not_found',
    VALIDATION: 'validation_error',
    CONFLICT: 'conflict',
    LEASE_CONFLICT: 'lease_conflict',
    TRANSITION_BLOCKED: 'transition_blocked',
    APPROVAL_REQUIREMENTS: 'approval_requirements',
    RATE_LIMITED: 'rate_limited',
    INTERNAL: 'internal_error',
};
//# sourceMappingURL=envelope.js.map